module.exports = __webpack_public_path__ + "static/media/GuideCollectionPageOS10Step2.14b109e2.gif";